var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('span',{staticClass:"p-4 font-weight-medium text--secondary",attrs:{"type":"button"},on:{"click":_vm.backTo}},[_vm._v("< Retour")])])}
var staticRenderFns = []

export { render, staticRenderFns }